import moment from "moment";

import { EQCourseSections } from "services/shortAnswerService/question-types/QuestionCourseSections";

import { SELF_MARKING_DONT_KNOW_MARK } from "features/exam-questions/consts";

export function getAssignmentCutoffTimeValues(
  dueDate: moment.Moment,
  cutoffDate: moment.Moment
) {
  if (cutoffDate.diff(dueDate, "weeks") < 1) {
    return [cutoffDate.diff(dueDate, "days"), "day"];
  }

  if (cutoffDate.diff(dueDate, "months") < 1) {
    return [cutoffDate.diff(dueDate, "weeks"), "week"];
  }

  return [cutoffDate.diff(dueDate, "months"), "month"];
}

export function getExamQuestionsInAssignmentSections({
  courseExamQuestions,
  courseId,
  assignmentSectionIds
}: {
  courseExamQuestions?: EQCourseSections[];
  courseId?: string;
  assignmentSectionIds: string[];
}) {
  return courseExamQuestions
    ?.filter(courseExamQuestion => {
      const associatedSectionsInAssignmentCourse =
        courseExamQuestion.courseSections.find(
          courseSection => courseSection.courseId === courseId
        )?.sectionIds;

      return assignmentSectionIds?.some(assignmentSectionId =>
        associatedSectionsInAssignmentCourse?.includes(assignmentSectionId)
      );
    })
    ?.map(courseExamQuestion => courseExamQuestion.questionId);
}

export function getMarkRatioTone(mark?: number, marksTotal?: number) {
  if (typeof mark === "undefined" || mark === SELF_MARKING_DONT_KNOW_MARK)
    return "neutral";

  if (mark === 0) {
    return "error";
  }

  if (mark === marksTotal) {
    return "success";
  }

  return "warning";
}

export function getFormattedMark(mark?: number, marksTotal?: number) {
  if (mark === undefined) return "--";

  if (mark === SELF_MARKING_DONT_KNOW_MARK) {
    return `? / ${marksTotal}`;
  }

  return `${mark} / ${marksTotal}`;
}
